<template>
  <div>
    <loading :active.sync="isLoading" :is-full-page="fullPage" :z-index="zIndex"></loading>
    <b-modal id="modalconfirmDelete" ref="modalconfirmDelete" title="Confirm">
      <p>Do you really want to remove the registry?</p>
      <p><b>Employer:</b> {{ experience.employer }}</p>
      <p><b>Position:</b> {{ experience.position }}</p>
      <template slot="modal-footer">
          <b-button variant="primary" class="mr-2" @click="confirmDelete">Confirm</b-button>
          <b-button variant="secondary" @click="hideConfirmDelete">Close</b-button>
      </template>
    </b-modal>
    <b-modal id="viewExperience" ref="viewExperience" size="lg" title="Work experience">
      <b-row>
        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
          <div class="form-group">
              <label>Employer</label>   
              <div class="input-group"> 
                {{ experience.employer }}
              </div>
          </div>
        </b-col>
        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
          <div class="form-group">
              <label>Position</label>   
              <div class="input-group"> 
                {{ experience.position }}
              </div>
          </div>
        </b-col>
        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
          <div class="form-group">
            <label>Start Date</label>   
            <div class="input-group"> 
              {{ experience.startDate  }}
            </div>
          </div>
        </b-col>
        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
          <div class="form-group">
            <label>End Date</label>   
            <div class="input-group"> 
              {{ experience.endDate  }}
            </div>
          </div>
        </b-col>
        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
          <b-form-group label="Annual Salary">
            {{ experience.salary | formatCurrency }}
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
          <b-form-group label="Volunteer Job">
            {{ experience.volunteerJob | formatYesNo }}
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
          <b-form-group label="Supervisor Name">
            {{ experience.supervisorName }}
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
          <b-form-group label="Supervisor Title">
            {{ experience.supervisorTitle }}
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="12" md="12" lg="12" xl="12">
          <div class="form-group">
            <label>Work description</label>   
            <quill-editor v-model="experience.workDescription" :options="editorOptionWithoutToolbar" disabled></quill-editor>
          </div>
        </b-col>
      </b-row>
      <template slot="modal-footer">
          <b-button variant="secondary" @click="hideViewExperience">Close</b-button>
      </template>
    </b-modal>
    <b-modal id="modalExperience" ref="modalExperience" size="lg" :title="(newExperience) ? 'Add work experience' : 'Edit work experience'">
      <b-row>
        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
          <div class="form-group">
            <label>Employer <span v-if="checkLabelRequired('employer')" class="text-danger">*</span></label>   
            <div class="input-group"> 
              <b-form-input id="employer" v-model="experience.employer" :state="$v.experience.employer.$dirty ? !$v.experience.employer.$error : null" required></b-form-input>
            </div>
          </div>
        </b-col>
        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
          <div class="form-group">
            <label>Position <span v-if="checkLabelRequired('position')" class="text-danger">*</span></label>   
            <div class="input-group"> 
              <b-form-input id="position" v-model="experience.position" :state="$v.experience.position.$dirty ? !$v.experience.position.$error : null" required></b-form-input>
            </div>
          </div>
        </b-col>
        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
          <div class="form-group">
            <label>Start Date <span v-if="checkLabelRequired('startDate')" class="text-danger">*</span></label>   
            <b-input-group class="mb-3">
               <b-form-input 
                id="startDate"                
                v-mask="['##/##/####']" 
                type="text" 
                placeholder="DD/MM/YYYY" 
                autocomplete="off"
                :value="experience.startDate"               
                :state="validateState('startDate')"                
                @blur="onBlurStartDate" >
              </b-form-input>
              <b-input-group-append>
                <b-form-datepicker 
                  :value="startDateObj" 
                  button-only 
                  close-button 
                  locale="pt" 
                  :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"                  
                  @input="updateStartDate">
                </b-form-datepicker>
              </b-input-group-append>
            </b-input-group>
          </div>
        </b-col>
        <b-col cols="12" sm="12" md="2" lg="2" xl="2">
          <div class="form-group">
            <label>On Going</label>   
            <div class="input-group"> 
              <b-form-checkbox v-model="experience.onGoing" :value="true"></b-form-checkbox>
            </div>
          </div>
        </b-col>
        <b-col v-if="!experience.onGoing" cols="12" sm="12" md="4" lg="4" xl="4">
          <div class="form-group">
            <label>End Date <span class="text-danger">*</span></label>   
            <b-input-group class="mb-3">
              <b-form-input 
                id="endDate"                 
                v-mask="['##/##/####']" 
                :value="experience.endDate" 
                :state="validateState('endDate')" 
                type="text" 
                placeholder="DD/MM/YYYY" 
                autocomplete="off"
                @blur="onBlurEndDate" >
              </b-form-input>
              <b-input-group-append>
                <b-form-datepicker 
                  :value="endDateObj"                  
                  button-only 
                  close-button                   
                  locale="pt" 
                  :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"                 
                  @input="updateEndDate">
                </b-form-datepicker>
              </b-input-group-append>
            </b-input-group>
          </div>
        </b-col>
        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
          <div class="form-group">
            <label>Annual Salary <span v-if="checkLabelRequired('salary')" class="text-danger">*</span></label>   
            <div class="input-group"> 
              <Money v-model="experience.salary" type="text" name="salary" v-bind="money" class="form-control" required maxlength="18"></Money>
            </div>
          </div>
        </b-col>
        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
          <div class="form-group">
            <label>Volunteer Job</label>   
            <div class="input-group"> 
              <b-form-checkbox v-model="experience.volunteerJob" :value="true"></b-form-checkbox>
            </div>
          </div>
        </b-col>
        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
          <div class="form-group">
            <label>Supervisor Name <span v-if="checkLabelRequired('supervisorName')" class="text-danger">*</span></label>   
            <div class="input-group"> 
              <b-form-input id="supervisorName" v-model="experience.supervisorName" :state="$v.experience.supervisorName.$dirty ? !$v.experience.supervisorName.$error : null" required></b-form-input>
            </div>
          </div>
        </b-col>
        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
          <div class="form-group">
            <label>Supervisor Title <span v-if="checkLabelRequired('supervisorTitle')" class="text-danger">*</span></label>   
            <div class="input-group"> 
              <b-form-input id="supervisorTitle" v-model="experience.supervisorTitle" :state="$v.experience.supervisorTitle.$dirty ? !$v.experience.supervisorTitle.$error : null" required></b-form-input>
            </div>
          </div>
        </b-col>
        <b-col cols="12" sm="12" md="12" lg="12" xl="12">
          <div class="form-group">
            <label>Work Description <span v-if="checkLabelRequired('workDescription')" class="text-danger">*</span></label>   
            <div class="input-group"> 
              <b-form-textarea id="textarea-default" v-model="experience.workDescription" :state="$v.experience.workDescription.$dirty ? !$v.experience.workDescription.$error : null" maxlength="250"></b-form-textarea>
            </div>
          </div>
        </b-col>
      </b-row>
      <template slot="modal-footer">
          <b-button variant="primary" class="mr-2" @click="saveExperience">Save</b-button>
          <b-button variant="secondary" @click="hideModal">Close</b-button>
      </template>
    </b-modal>
      <div class="card-body">
        <h5 class="card-title">Professional experience</h5>
        <div class="row">
            <div v-for="exp in experiences" :key="exp.id" class="col-md-3 col-xs-12">
                <b-card header-tag="header" footer-tag="footer">
                <template v-slot:header>
                  <h6 class="mb-0">{{ exp.employer }}</h6>
                </template>
                <b-card-text>
                  <p><b>{{ exp.position }}</b></p>
                  <p>Period: {{ exp.startDate   }} - <span v-if="exp.endDate">{{ exp.endDate  }}</span><span v-if="exp.onGoing">On Going</span></p>
                  <p>Annual Salary: {{ exp.salary | formatCurrency }}</p>
                  </b-card-text>
                <template v-slot:footer>
                  <b-button size="xs" variant="primary" class="mr-1" @click="viewExperience(exp)"><i class="fas fa-eye"></i></b-button>
                  <b-button size="xs" variant="primary" class="mr-1" @click="editExperience(exp)"><i class="fas fa-edit"></i></b-button>
                  <b-button size="xs" variant="danger"  class="mr-1" @click="deleteExperience(exp)"><i class="far fa-trash-alt"></i></b-button>
                </template>
              </b-card>
            </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <b-button variant="primary" @click="addExperience">Add experience</b-button>
          </div>
        </div>
      </div>
      <div>
        <areaOfExpertise :id="CurriculumId" @reload-curriculum="loadCurriculum"></areaOfExpertise>
      </div>
  </div>
</template>

<script>
import { authMethods, editorConfig, moneyFormat, editorConfigWithoutBar } from '@state/helpers'
import appConfig from '@src/app.config'
import loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import axios from 'axios'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import { quillEditor } from 'vue-quill-editor'
import { Money } from 'v-money'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import moment from 'moment'
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/pt-br';
import areaOfExpertise from './areaOfExpertise'

var qs = require('qs')

export default {
  components: { loading, quillEditor, Money, areaOfExpertise },
  mixins: [validationMixin],
  props: {
    user: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    agency: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    id: { type: String, default: () => ({}) }
  },
  data () {
    return {
      startDate: "",
      endDate: "",
      SequenceId : this.sequenceId,
      CurriculumId: this.id,
      GeneralData: {},
      experiences: [],
      experience: {},
      newExperience: false,
      isLoading: false,
      fullPage: false,
      zIndex: 9999,
      editorOption: editorConfig,
      editorOptionWithoutToolbar: editorConfigWithoutBar,
      money: moneyFormat,
      requiredFields: [],
      momentFormat: {
        stringify: (date) => {
          return date ? moment(date).format('DD/MM/YYYY') : ''
        },
        parse: (value) => {
          return value ? moment(value, 'DD/MM/YYYY').toDate() : null
        }
      }
    }
  },
  computed: {
    // a computed getter
    startDateObj() {
      // `this` points to the component instance
      if (this.experience.startDate) {
        return moment(this.experience.startDate, "DD/MM/YYYY").toDate()
      }
      return moment().toDate()      
    },
    endDateObj() {
      // `this` points to the component instance
      if(this.experience.endDate) {
         return moment(this.experience.endDate, "DD/MM/YYYY").toDate()
      }
      return moment().toDate()     
    }
  },
  validations() {
    return {
      experience: {
        employer: this.checkDynamicRequired('employer'),
        position: this.checkDynamicRequired('position'),
        startDate: this.checkDynamicRequired('startDate'),
        salary: this.checkDynamicOrZeroRequired('salary'),
        supervisorName: this.checkDynamicRequired('supervisorName'),
        supervisorTitle: this.checkDynamicRequired('supervisorTitle'),
        workDescription: this.checkDynamicRequired('workDescription'),
        endDate: !this.experience.onGoing ? { required } : {}
      }
    }
  },
  watch: {
    'experience.onGoing': {
      handler: function (value) {
        if (value) {
          this.experience.endDate = null
        }
      }
    },     
  },
  created () {
    this.loadExperiences()
    this.loadRequiredFields()
  },
  methods: {
    ...authMethods,
    loadCurriculum(){
      this.$emit('reload-curriculum')
    },
    loadRequiredFields () {
      axios.get(`${appConfig.apiUrl}required-fields/${this.agency.id}/only/professionalExperience`,
      { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
      .then((response) => {
        this.requiredFields = response.data
      })
    },
    checkDynamicRequired (field) {
      if (this.requiredFields.find(f => f.aliasId === field && f.selected === true)) {
        return { required }
      }
      return {}
    },
    checkLabelRequired (field) {
      if (this.requiredFields.find(f => f.aliasId === field && f.selected === true)) {
        return true
      }
      return false
    },
    validateState (name) {
      const { $dirty, $error } = this.$v.experience[name];
      return $dirty ? !$error : null;
    },
    checkDynamicOrZeroRequired (field) {
      if (this.requiredFields.find(f => f.aliasId === field && f.selected === true)) {
        return { required }
      }
      return {}
    },
    loadExperiences() {
      axios.get(appConfig.apiUrl + 'work-experience/' + this.CurriculumId,
      { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
      .then((response) => {
        if(response.data) {
          this.experiences = response.data
          this.experiences.forEach(element => {
            element.startDate = moment(element.startDate).format("DD/MM/YYYY")
            element.endDate = moment(element.endDate).format("DD/MM/YYYY")
          });
        }
      })
      .catch(error => {
        this.loginCheck(error.response.status)
        this.$notify({group: 'alert', type: 'warn', title: 'Request Error', text: error});
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    addExperience() {
      this.newExperience = true
      this.experience = {
        curriculumId: this.CurriculumId,
        startDate: null,
        endDate: null
      }
      this.$refs['modalExperience'].show()
    },
    editExperience (experience) {
      this.newExperience = false
      this.experience = experience
      this.$refs['modalExperience'].show()
    },
    deleteExperience (experience) {
      this.experience = experience
      this.$refs['modalconfirmDelete'].show()
    },
    viewExperience (experience) {
      this.experience = experience
      this.$refs['viewExperience'].show()
    },
    hideModal () {
      this.$refs['modalExperience'].hide()
      this.$v.experience.$reset()
    },
    hideConfirmDelete () {
      this.$refs['modalconfirmDelete'].hide()
    },
    hideViewExperience () {
      this.$refs['viewExperience'].hide()
    },
    confirmDelete () {
      this.isLoading = true
      axios.delete(appConfig.apiUrl + `work-experience/${this.experience.id}`,
        { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } })
        .then(response => {
          this.$notify({group: 'alert', type: 'success', title: 'Success', text: 'Deleted Successful.'});
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({group: 'alert', type: 'error', title: 'Request Error', text: error});
        })
        .finally(() => {
          this.loadExperiences()
          this.isLoading = false
          this.$emit('reload-curriculum')
          this.hideConfirmDelete()
        })
    },
    saveExperience() {
      
      this.$v.experience.$touch()
      if (this.$v.experience.$anyError) {
        this.$notify({group: 'alert', type: 'error', title: 'Form Validation', text: 'Please complete all required fields.'});
        return
      }

      if (this.experience.endDate) {
        if (moment(this.experience.endDate, "DD/MM/YYYY") < moment(this.experience.startDate, "DD/MM/YYYY")) {
          this.$notify({group: 'alert', type: 'error', title: 'Form Validation', text: 'End date cannot be less than the start date.'});
          return
        }
      }

      if (!this.experience.endDate && !this.experience.onGoing) {
        this.$notify({group: 'alert', type: 'error', title: 'Form Validation', text: 'Please inform the end date or on going.'});
        return
      }

      this.isLoading = true
      let exx = this.experience;
      exx.startDate = moment(this.experience.startDate, "DD/MM/YYYY").format("MM/DD/YYYY")
      exx.endDate = moment(this.experience.endDate, "DD/MM/YYYY").format("MM/DD/YYYY")
      axios.post(appConfig.apiUrl + 'work-experience/save',        
        qs.stringify(exx),
        { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } })
        .then(response => {
          this.$notify({group: 'alert', type: 'success', title: 'Success', text: 'Saved Successful.'});
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({group: 'alert', type: 'error', title: 'Request Error', text: error});
        })
        .finally(() => {
          this.isLoading = false
          this.loadExperiences()
          this.$emit('reload-curriculum')
          this.hideModal()
        })
    },
    updateStartDate(ctx) { 
      if (ctx) {
        this.experience.startDate = moment(ctx).format("DD/MM/YYYY")
      }     
          
    },
    updateEndDate(ctx) {      
      if(ctx) {
        this.experience.endDate = moment(ctx).format("DD/MM/YYYY")
      }      
    },
    onBlurStartDate(ctx) {
      if (ctx) {
        this.experience.startDate = ctx.target.value
      }
           
    },
    onBlurEndDate(ctx) {
      if (ctx) {
        this.experience.endDate = ctx.target.value
      }      
    }

  }
}
</script>

<style>

</style>
